import { defineFcm } from '../shared/factory';

export const FCM_MEMBER_PHONE_COLLECTION = defineFcm('member_phone_collection')
	.asBoolean()
	.withDefault(false)
	.toConfig({
		owner: 'squad-koi',
		scope: 'corgi-front-end',
		context: 'Membership Page',
		description: 'If true, phone number collection input will be visible for all users other than secure guests',
		import: false,
	});
